import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import ServicesPage from '../pages/services/page';
import AboutPage from '../pages/about/page';
import BrooklynPage from '../pages/brooklyn/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/services', element: <ServicesPage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/brooklyn', element: <BrooklynPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
